<template>
    <VueDatePicker
        :id="id"
        v-model="date"
        :input-attrs="{
            name: name,
            id: name,
            required: isRequired,
        }"
        model-type="yyyy-MM-dd"
        :formats="{ input: 'yyyy-MM-dd' }"
        :min-date="minDate"
        :max-date="maxDate"
        :preset-dates="presetDates"
        :time-config="{ enableTimePicker: false }"
        :clearable="clearButton"
        :disabled="isDisabled"
        :required="isRequired"
        :teleport="true"
        auto-apply
        input-class-name="form-control"
        @update:model-value="onChange"
    />
</template>

<script>
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default {
    name: 'DatePicker',

    components: {
        VueDatePicker,
    },

    props: {
        id: String,
        name: String,
        value: String,
        format: String,
        disableDatesTo: String,
        disableDatesFrom: String,
        clearButton: Boolean,
        isRequired: Boolean,
        shouldEmitEvent: Boolean,
        isDisabled: { type: Boolean, default: false },
    },

    data() {
        return {
            date: null,
            minDate: null,
            maxDate: null,
        };
    },

    computed: {
        presetDates() {
            return [
                { label: 'Today', value: new Date() },
            ];
        },
    },

    created() {
        if (this.value) {
            const date = this.value === 'today'
                ? new Date()
                : this.getDateFromString(this.value);

            this.setDate(date);
        }

        if (this.disableDatesTo) {
            this.minDate = this.getDateFromString(this.disableDatesTo);
        }

        if (this.disableDatesFrom) {
            this.maxDate = this.getDateFromString(this.disableDatesFrom);
        }

        const eventName = 'set' + this.name.replace(/^\w/, c => c.toUpperCase());

        window.events.on(eventName, value => {
            this.setDate(value);
        });
    },

    methods: {
        getDateFromString(value) {
            if (! value) {
                return null;
            }

            const separator = value.includes('-') ? '-' : '/';
            const parts = value.split(separator);

            const [day, month, year] = separator === '-'
                ? [parts[2], parts[1], parts[0]]
                : [parts[0], parts[1], parts[2]];

            const date = new Date(Number(year), Number(month) - 1, Number(day));

            return this.isValidDate(date) ? date : null;
        },

        isValidDate(date) {
            return date instanceof Date && ! isNaN(date.getTime());
        },

        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        },

        setDate(value) {
            if (! value) {
                this.date = null;
                return;
            }

            const date = value instanceof Date ? value : this.getDateFromString(value);

            this.date = this.isValidDate(date) ? this.formatDate(date) : null;
        },

        onChange(value) {
            this.broadcast(value);
        },

        broadcast(value) {
            if (! this.shouldEmitEvent) {
                return;
            }

            // value is already a "yyyy-MM-dd" string (model-type), or null when cleared.
            const name = 'update' + this.name.replace(/^\w/, c => c.toUpperCase());

            window.events.emit(name, value || '');
        },
    },
};
</script>
